import { render, staticRenderFns } from "./SalesStatisticCard.vue?vue&type=template&id=2a76c391&"
import script from "./SalesStatisticCard.vue?vue&type=script&lang=js&"
export * from "./SalesStatisticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports